export default __webpack_public_path__ + "static/media/maximize-hover.e9c725ff.svg";